export class CorporateTravelData {
  businessName: string;
  name: string;
  email: string;
  phone: string;
}
